module.exports = __webpack_public_path__ + "img/news-image3.dc85d38d.png";